// extracted by mini-css-extract-plugin
export var warning = "ConfirmDetailsMessages-module--warning--206CO";
export var warningContainer = "ConfirmDetailsMessages-module--warningContainer--GVcqi";
export var warningItems = "ConfirmDetailsMessages-module--warningItems--mdwbd";